<form class="flex-col flex" #form="ngForm">
    <mat-card>
        <mat-card-header class="cb-margin-bottom-2x">
            <mat-card-title>
                <div class="start-center flex-row">
                    <mat-icon
                        [ngClass]="getStatusIconClass()"
                        class="help-cursor cb-margin-right-2x"
                        [matTooltip]="getStatusIconTitle()"
                        >{{ getStatusIconIcon() }}
                    </mat-icon>
                    <span>Import #{{ mappedItem.id }}</span>
                </div>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content class="cb-margin-bottom cb-margin-bottom">
            <div class="flex-col flex">
                @if (mappedItem?.createdDate && mappedItem?.createdByName) {
                    <cb-user-date-time-new
                        label="Imported"
                        [date]="mappedItem?.createdDate"
                        [userFullName]="mappedItem?.createdByName"
                    >
                    </cb-user-date-time-new>
                }
                @if (mappedItem?.updatedDate && mappedItem?.updatedByName) {
                    <cb-user-date-time-new
                        label="Updated"
                        [date]="mappedItem?.updatedDate"
                        [userFullName]="mappedItem?.updatedByName"
                    >
                    </cb-user-date-time-new>
                }
            </div>
        </mat-card-content>
        <mat-divider class="card-divider"></mat-divider>
        <mat-card-actions class="end-center flex-row layoutGap-16">
            @if (mappedItem.transferHistoryId) {
                <cb-button
                    color="white"
                    [isStroked]="true"
                    icon="file_download"
                    buttonLabel="Download"
                    (clicked)="getTransferHistoryFile()"
                >
                </cb-button>
            }
            <span class="flex"></span>
            @if (mappedItem.transferHistoryId) {
                <cb-button
                    color="accent"
                    [isStroked]="true"
                    [disabled]="!canViewTakeOff"
                    (clicked)="goToTakeOff()"
                >
                    Manage
                </cb-button>
            }
        </mat-card-actions>
    </mat-card>
</form>
